import { combineReducers } from 'redux';
import bankAccount from '../../pages/guest/bankAccount/store/reducer';

const reducers = combineReducers({
  bankAccount,
});

export default reducers;
